import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลต้นแหล่ง
function* sourceQualityEvaluationLoadLocation(action) {
  const {
    data: { location_list, location_type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/get-location`,
      { location_list, location_type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadLocation.failure())
  }
}

// *load ข้อมูลวัตถุดิบ
function* sourceQualityEvaluationLoadRawMaterial(action) {
  const {
    data: { origin_location_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/get-material-by-origin-location`,
      { origin_location_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadRawMaterial.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadRawMaterial.failure())
  }
}

// *load ข้อมูลวัตถุดิบสำหรับหน้า create
function* sourceQualityEvaluationLoadRawMaterialForCreate(action) {
  const {
    data: { origin_location_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/get-material-by-origin-location`,
      { origin_location_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.sourceQualityEvaluationLoadRawMaterialForCreate.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadRawMaterialForCreate.failure())
  }
}

// *load table log ประเมินคุณภาพ
function* sourceQualityEvaluationLoadTableLog(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      location_visibility,
      filterObj,
      limit_export,
      file_value_pdf,
      type,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/log`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        location_visibility,
        filterObj,
        limit_export,
        file_value_pdf,
        type,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadTableLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadTableLog.failure())
  }
}

//  *load ข้อมูล form ประเมินคุณภาพ
function* sourceQualityEvaluationLoadRequestForm(action) {
  const {
    data: { material_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/request-form`,
      { material_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadRequestForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadRequestForm.failure())
  }
}

// *load detail ประเมินคุณภาพ
function* sourceQualityEvaluationLoadDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/detail`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadDetail.failure())
  }
}

// *create form ประเมินคุณภาพ
function* sourceQualityEvaluationCreateForm(action) {
  const {
    data: { data_for_api, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/create`,
      {
        ...data_for_api,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationCreateForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationCreateForm.failure())
  }
}

// *ลบข้อมูล form ประเมินคุณภาพ
function* sourceQualityEvaluationDeleteForm(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/delete`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationDeleteForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationDeleteForm.failure())
  }
}

// *calculate form ประเมินคุณภาพ
function* sourceQualityEvaluationCalculateForm(action) {
  const {
    data: {
      form,
      answer,
      dry_weight_of_original_sample,
      material_id,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/calculator-quality-control-results`,
      { form, answer, dry_weight_of_original_sample, material_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationCalculateForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationCalculateForm.failure())
  }
}

// *export 1 form ประเมินคุณภาพ
function* sourceQualityEvaluationExportOneForm(action) {
  const {
    data: { id, type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/export`,
      { id, type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationExportOneForm.success(res.data))

    // window.location.assign(`${res.data.data}`)
    window.open(`${res.data.data}`, '_blank')
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationExportOneForm.failure())
  }
}
// *export หลาย form ประเมินคุณภาพ
function* sourceQualityEvaluationExportMultipleForm(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/multiple-export`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.sourceQualityEvaluationExportMultipleForm.success(res.data)
    )

    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationExportMultipleForm.failure())
  }
}

// *load ข้อมูล test center
function* sourceQualityEvaluationLoadTestCenter(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/load-test-center`,
      { location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationLoadTestCenter.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationLoadTestCenter.failure())
  }
}

// *export ข้อมูล log ประเมินคุณภาพ
function* sourceQualityEvaluationExportExcel(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      location_visibility,
      filterObj,
      limit_export,
      file_value_pdf,
      type,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/log`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        location_visibility,
        filterObj,
        limit_export,
        file_value_pdf,
        type,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityEvaluationExportExcel.success(res.data))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationExportExcel.failure())
  }
}

// *edit form ประเมินคุณภาพ
function* sourceQualityEvaluationEditForm(action) {
  const {
    data: { data_for_api, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/update`,
      {
        ...data_for_api,
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )

    yield put(actions.sourceQualityEvaluationEditForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationEditForm.failure())
  }
}

export default function* watchSourceQualityEvaluation() {
  yield all([
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_LOCATION.REQUEST,
      sourceQualityEvaluationLoadLocation
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST,
      sourceQualityEvaluationLoadRawMaterial
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.REQUEST,
      sourceQualityEvaluationLoadRawMaterialForCreate
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_TABLE_LOG.REQUEST,
      sourceQualityEvaluationLoadTableLog
    ),

    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_REQUEST_FORM.REQUEST,
      sourceQualityEvaluationLoadRequestForm
    ),

    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_DETAIL.REQUEST,
      sourceQualityEvaluationLoadDetail
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_CREATE.REQUEST,
      sourceQualityEvaluationCreateForm
    ),

    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_DELETE.REQUEST,
      sourceQualityEvaluationDeleteForm
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_CALCULATE.REQUEST,
      sourceQualityEvaluationCalculateForm
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM.REQUEST,
      sourceQualityEvaluationExportOneForm
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.REQUEST,
      sourceQualityEvaluationExportMultipleForm
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_TEST_CENTER.REQUEST,
      sourceQualityEvaluationLoadTestCenter
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST,
      sourceQualityEvaluationExportExcel
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_EDIT.REQUEST,
      sourceQualityEvaluationEditForm
    ),
  ])
}
export {
  sourceQualityEvaluationLoadLocation,
  sourceQualityEvaluationLoadRawMaterial,
  sourceQualityEvaluationLoadRawMaterialForCreate,
  sourceQualityEvaluationLoadTableLog,
  sourceQualityEvaluationLoadRequestForm,
  sourceQualityEvaluationLoadDetail,
  sourceQualityEvaluationCreateForm,
  sourceQualityEvaluationDeleteForm,
  sourceQualityEvaluationCalculateForm,
  sourceQualityEvaluationExportOneForm,
  sourceQualityEvaluationExportMultipleForm,
  sourceQualityEvaluationLoadTestCenter,
  sourceQualityEvaluationExportExcel,
  sourceQualityEvaluationEditForm,
}
